import { DateTime, DynamicLoad } from '../../../commons/loadDrawer/components/ticketTab/types';
import { LocationStatus } from '../commons/utils/LoadStatusBarUtils';

export enum BcMessage {
  dropElement = 'REMOVE_ELEMENT',
  setDraggingFromTable = 'SET_DRAGGING_FROM_TABLE',
  setDraggingFromDriver = 'SET_DRAGGING_FROM_DRIVER',
  setRefreshData = 'SET_REFRESH_DATA'
}

export type handleFunctionDNDType = ((type: BcMessage) => void) | null;

export type ScheduleBy = 'DRIVER' | 'LOAD';
export type UseCalculation = 'YES' | 'NO';

export interface ScheduleEntry {
  driver: Driver;
  entryList?: LoadEntry[] | null;
  totalEntryList: number;
}

export interface Driver {
  isLoggedIn?: boolean;
  isLateAtShift?: boolean;
  isWorking?: boolean;
  id: number;
  isActive: boolean;
  is3rdParty: boolean;
  is3rdPartyUser: boolean;
  contractor: any;
  isSleeper: boolean;
  isSlipSeat: boolean;
  isDay: boolean;
  isNight: boolean;
  isAllTruckAssigned: boolean;
  isAllTrailerAssigned: boolean;
  isDriverHold: boolean;
  isBlockDispatch: boolean;
  isMoveLoadNextShiftDayDisabled: boolean;
  contact: Partial<Contact>;
  supervisorId: number;
  preferredAccount: Partial<PreferredAccount>;
  resetDays?: Partial<ResetDaysEntityOrProductType>[] | null;
  colorCode: number;
  orgId: number;
  shift?: Partial<Shift>;
  notes?: Note[] | null;
  isOilfieldTransportAllowed: boolean;
  isOilWellServiceAllowed: boolean;
  isYardMoveAllowed: boolean;
  isPersonalConveyanceAllowed: boolean;
  isScheduleOnOff: boolean;
  isApiPartialUpdate: boolean;
  isDriverAddedRearrangeLoadNoteRequired: boolean;
  isDriverAddedRerouteDropOffNoteRequired: boolean;
  day: boolean;
  active: boolean;
  sleeper: boolean;
  slipSeat: boolean;
  night: boolean;
  driverHold: boolean;
  blockDispatch: boolean;
  scheduleOnOff: boolean;
  lockDriverAllowedToRerouteDropOff: boolean;
  lockDriverAllowedToRearrangeLoad: boolean;
  allTruckAssigned: boolean;
  moveLoadNextShiftDayDisabled: boolean;
  oilfieldTransportAllowed: boolean;
  allTrailerAssigned: boolean;
  oilWellServiceAllowed: boolean;
  lockDriverAllowedToAddTank: boolean;
  personalConveyanceAllowed: boolean;
  driverAddedLoadNoteRequired: boolean;
  driverAllowedToAddTank: boolean;
  driverAllowedToAddLoad: boolean;
  driverHoldNotes?: string;
  yardMoveAllowed: boolean;
  driverAddedTankNoteRequired: boolean;
  driverAllowedToRerouteDropOff: boolean;
  driverAllowedToRearrangeLoad: boolean;
  lockDriverAllowedToAddLoad: boolean;
  scheduleStartDate?: DateObject | null;
  daysOn?: number[] | null;
  daysOff?: number[] | null;
  phoneBookList?: PhoneBookList[];
  hosText?: HOSText;
  driverGroupList?: any[] | null;
  driverCompany?: any;
  workStartTimeHour?: number;
  workStartTimeMinute?: number;
  workStartTimeZone?: string;
  isOnPTO?: boolean;
}

export interface PhoneBookList {
  phone1: number;
  phone2: number;
  email1: string;
  email2: string;
}

export interface Contact {
  streetLine1?: string | null;
  city?: string | null;
  county: string;
  state: string;
  zip5: string;
  country: string;
  geocode: Geocode;
  firstName?: string;
  lastName?: string;
  fullName: string;
  sourceId: number;
  sourceType: string;
  computedGeocode: Geocode;
  phone1: number;
  phone2: number;
  timeZone: number;
  geoCodeValid: boolean;
}

export interface PreferredAccount {
  id: number;
  contact: Partial<Contact>;
  colorCode: number;
  runTicketReportId: number;
  areConfirmationNosUnique: boolean;
  isApiPartialUpdate: boolean;
  isShortHandTicketNumber: boolean;
  isLockShowHideTimesRunTicket: boolean;
  isShowHideTimesRunTicket: boolean;
}

export interface ResetDaysEntityOrProductType {
  id: number;
  parentId: number;
  layoutId: number;
  description: string;
  status: boolean;
  layoutReadOnly: boolean;
  isOn: boolean;
  isReadOnly: boolean;
}

export interface Note {
  createdFor: Partial<Contact>;
  createdBy: Partial<Contact>;
  lastModifiedBy: Partial<Contact>;
  createdDateTime: Partial<DateObject>;
  lastModifiedDateTime: Partial<DateObject>;
  shiftDate: Partial<DateObject>;
  notes: string;
  archived: boolean;
}

export interface DateObject {
  date: string;
  time: string;
  empty: boolean;
  javaDate: number;
  sqldate: string;
  timeInMinutes: number;
  sqltimestamp: number;
  sqldateWithQuotes: string;
  timeInMilliseconds: number;
  sqltimestampWithQuotes: string;
}

export interface Shift {
  loginDateTime?: any;
  shiftDate: DateObject;
  lastKnownLocation: LastKnownLocation;
  timeAvailableEntireDay: number;
  timeAvailable: number;
  minutesToFinishUndoneLoads: number;
  totalLoadsAssigned: number;
  totalAssignedTime: number;
  deadHeadedMilesSum: number;
  loadedMilesSum: number;
  shiftStartDateTime: DateObject;
  odometerStart: number;
  odometerEnd: number;
  isVehicleInspectionDone: boolean;
  revenueSum: number;
  deadHeadedMilesSumEst?: number;
  logoutDateTime: LogoutDateTime;
  loadRearrangeNoteList?: any[];
  driverHOSAvailability: any;
  truck: TruckTrailer;
  trailer: TruckTrailer;
  appVersionNumber: string;
  appVersionNumberGoogleMaps: string;
  coDriverId?: number;
}

export interface TruckTrailer {
  truckNumber: string;
}

export interface LogoutDateTime {
  date: string;
  time: string;
}

export interface LastKnownLocation {
  geocode: Geocode;
  sourceId: number;
  sourceType: string;
  phone1: number;
  phone2: number;
  timeZone: number;
  geoCodeValid: boolean;
}

export interface Geocode {
  latitude: number;
  longitude: number;
  valid: boolean;
}

export interface LoadEntry {
  load: Load;
  dynamicLoad: DynamicLoad;
  isOverTime?: boolean;
  driverShiftDate: DateObject;
  driverShiftSequenceNo: number;
  dispatcherLoaddAssignedUserId: number;
  driverAcceptedDateTime: DateTime;
  locationList?: LocationListEntity[] | null;
  segmentList?: SegmentListEntity[] | null;
  deadHeadedMilesEstimated: number;
  deadHeadedMilesActual: number;
  loadedMilesSum: number;
  totalTimeEstimated: number;
  totalTimeActual: number;
  revenue: number;
  costing: number;
  netBarrels: number;
  grossBarrels: number;
  modified: boolean;
  aging?: number;
  tickets?: any;
  statusBars?: LocationStatus[];
  lastState?: number;
  isAllReject?: boolean;
}

export interface Load {
  id: number;
  billOfLadingNumber: string;
  status: string;
  pickUpAccount: PickUpAccount;
  pickUpList?: PickUpListEntity[] | null;
  confirmationNos?: string[] | null;
  dropOffAccount: DropOffAccount;
  dropOffList?: DropOffListEntity[] | null;
  loadedMiles: number;
  averageSpeed: number;
  requestedPickUpDate: DateObject;
  requestedDropOffDate: DateObject;
  isUrgent: boolean;
  isBackhaul: boolean;
  isLoadDuplicate: boolean;
  createdByUserId: number;
  source: string;
  estimatedTravelTime: number;
  estimatedNonDriveTime: number;
  isDuplicateConfirmationNo: boolean;
  commodityId: number;
  revenue: number;
  odometerAtStartOfLoad: number;
  loadedMilesValueKnown: boolean;
  dropOffChangeNotesList?: any;
  loadRejectFlag?: any;
  loadInstructions?: string;
  parentStateReferenceCode?: string;
  childStateReference?: string;
  parentStateReference?: string;
  childStateReferenceCode?: string;
  extraData?: any;
  parentHostId?: any;
  partiallyFinished: boolean;
}

export interface LoadRquirementsResponse {
  billOfLadingNumber?: string;
  confirmationNumber?: string;
  info?: string;
  validationResponses?: LoadRequirementsValidationResponse[];
}

export interface LoadRequirementsValidationResponse {
  blocking: boolean;
  name: string;
  requirement: string;
}

export interface IIndexable {
  [key: string]: any;
}

export interface PickUpAccount {
  id: number;
  contact: Partial<Contact>;
  colorCode: number;
  accountDistrictList?: AccountDistrictListEntity[] | null;
  runTicketReportId: number;
  areConfirmationNosUnique: boolean;
  isApiPartialUpdate: boolean;
  isShortHandTicketNumber: boolean;
  isLockShowHideTimesRunTicket: boolean;
  isShowHideTimesRunTicket: boolean;
}

export interface AccountDistrictListEntity {
  id: number;
  accountID: number;
  contact: Partial<Contact>;
  isActive: boolean;
  averageNumberOfLoadsPerShift: number;
}

export interface PickUpListEntity {
  id: number;
  isActive: boolean;
  contact: Partial<Contact>;
  leaseNumberAlphaNumeric?: string | null;
  operator: Operator;
  isMarketerBuyerLocked: boolean;
  isReceiptImageRequired: boolean;
  isReceiptNumberRequired: boolean;
  dryHaul: boolean;
  isBobTailLoad: boolean;
  isDayCab: boolean;
  percentLoadsRejected: number;
  averageGravity: number;
  avgLoadTime: number;
  avgLoadTimeCount: number;
  isAccepted?: boolean;
  avgWaitTime: number;
  avgWaitTimeCount: number;
  avgSpeed: number;
  averageSulphur: number;
  tanksList?: TanksListEntity[] | null;
  hasEntryPoint: boolean;
  postEntryPointMiles: number;
  roughRoadRoundTripMiles: number;
  commodityId: number;
  layoutId: number;
  isApiPartialUpdate: boolean;
  dynamicFields?: any[] | null;
  productType: ProductType;
  defaultCF: number;
  isLockCF: boolean;
  isLockDefaultGaugeType: boolean;
}

export interface Operator {
  id: number;
  createdBy: number;
  contact: Partial<Contact>;
  isActive: boolean;
  isApiPartialUpdate: boolean;
}

export interface TanksListEntity {
  id: number;
  sequenceNo: number;
  siteId: number;
  tankIsActive: boolean;
  tankNumber: string;
  isCallDispatch: boolean;
  isDriverSelect: boolean;
  isToBeReviewed: boolean;
  barrelsPerInch: number;
  capacity: number;
  height: number;
  minBottomGauge: number;
  lastModifiedDate: DateObject;
  addedBySourceId: number;
  addedBySourceType: string;
  tankStrapType: string;
  isSelectedInLoad: boolean;
}

export interface LastModifiedDate {
  empty: boolean;
  timeInMinutes: number;
  sqldateWithQuotes: string;
  timeInMilliseconds: number;
  sqltimestampWithQuotes: string;
}

export interface ProductType {
  id: number;
  parentId: number;
  layoutId: number;
  status: boolean;
  layoutReadOnly: boolean;
  isOn: boolean;
  isReadOnly: boolean;
  description?: string | null;
}

export interface DropOffAccount {
  id: number;
  contact: Partial<Contact>;
  colorCode: number;
  runTicketReportId: number;
  areConfirmationNosUnique: boolean;
  isApiPartialUpdate: boolean;
  isShortHandTicketNumber: boolean;
  isLockShowHideTimesRunTicket: boolean;
  isShowHideTimesRunTicket: boolean;
}

export interface DropOffListEntity {
  id: number;
  contact: Partial<Contact>;
  dropOffNumber: number;
  isReceiptImageRequired: boolean;
  isReceiptNumberRequired: boolean;
  avgUnLoadTime: number;
  avgUnLoadTimeCount: number;
  avgWaitTime: number;
  avgWaitTimeCount: number;
  hasEntryPoint: boolean;
  postEntryPointMiles: number;
  layoutId: number;
  commodityId: number;
  isApiPartialUpdate: boolean;
  dynamicFields?: any[] | null;
  productType: ProductType;
}

export interface LocationListEntity {
  loadId: number;
  sequenceNo: number;
  locationType: string;
  locationId: number;
  status: StatusLocationTypes;
  isLocation: boolean;
  contact: Partial<Contact>;
  isGeocodeComputed: boolean;
  arrivalDateTimeProjected: Partial<DateObject>;
  arrivalDateTimeEstimated: Partial<DateObject>;
  arrivalDateTimeActual: Partial<DateObject>;
  arrivalGeocodeActual: Geocode;
  entryPointDateTimeEstimated: Partial<DateObject>;
  entryPointDateTimeActual: Partial<LastModifiedDate>;
  entryPointGeocodeActual: Geocode;
  departureDateTimeProjected: Partial<DateObject>;
  departureDateTimeEstimated: Partial<DateObject>;
  departureDatetimeActual: Partial<DateObject>;
}

export interface SegmentListEntity {
  loadId: number;
  sequenceNoStartLocation: number;
  sequenceNoEndLocation: number;
  status: string;
  travelMilesEstimated: number;
  travelMilesActual: number;
  travelTimeEstimated: number;
  travelTimeActual: number;
}

export type StatusLocationTypes = 'PENDING' | 'ARRIVED' | 'COMPLETE' | 'CANCELLED' | 'REJECT' | 'DRIVING' | '';

export type DispatchDnDMessageType =
  | 'DRIVER_NOT_WORKING'
  | 'DRIVER_BLOCKED_DISPATCH'
  | 'DRIVER_SOURCE_BLOCKED_DISPATCH'
  | 'SELECTED_LOAD_STATUS_CANT_MOVE'
  | 'TARGET_LOAD_STATUS_CANT_MOVE'
  | 'SELECTED_LOAD_NOT_MOVED_TODAY'
  | 'TARGET_LOAD_NOT_MOVED_TODAY'
  | 'DRIVER_ALREADY_PICK_UP_THE_LOAD'
  | 'MORE_THAN_ONE_LOADS_WITHOUT_DROP_OFF'
  | 'LOAD_WITH_RR'
  | 'LOAD_WITH_UR'
  | '';

export interface IDispatchCompanyInfo {
  dispatchAgingColor0: any;
  dispatchAgingColor1: any;
  dispatchAgingColor2: any;
  dispatchLoadDragColor: any;
  driverDayShiftStartTimeHHMM: string;
  driverNightShiftStartTimeHHMM: string;
  driverLateStartShiftMinutes: number;
  dispatchMinutesToYellowWarning: number;
  dispatchMinutesToRedWarning: number;
}

export interface HOSText {
  hosRestIn?: string;
  hosDrivingLeft?: string;
  hostDutyLeft?: string;
  hosCycleLeft?: string;
  hosRestInWarning?: WarningType;
  hosDrivingLeftWarning?: WarningType;
  hostDutyLeftWarning?: WarningType;
  hosCycleLeftWarning?: WarningType;
}
export interface ParamsToSendEmail {
  pickUpIdArr: any[];
  commodityId: number;
  loadIdArr: any[];
  message: string;
  dropOffIdArr: any[];
  emailParticipantList: any[];
  ccEmailParticipantList?: any[];
}

export type WarningType = 'RED' | 'YELLOW' | '';

export type DefaultDrawerTab =
  | 'pickup'
  | 'dropoff'
  | 'ticket'
  | 'load'
  | 'map'
  | 'imagesVideos'
  | 'invoice'
  | 'payroll';

export enum ParentAndChildStatusCodes {
  TRANSMITTING = 'T',
  PENDING = 'P',
  ACCEPTED = 'A',
  RETURNED = 'R',
  RETURN_REQUESTED = 'RR',
  DRIVER_ASSIGNED = 'D',
  COMPLETED = 'C',
  RETURN_REQUEST_ACCEPTED = 'RRA',
  RETURN_REQUEST_DENIED = 'RRD',
  RETURN_ACCEPTED = 'RA',
  UPDATE_REQUESTED = 'UR',
  UPDATE_REQUESTED_RESPONDED = 'URR',
  UPDATE_REQUESTED_ACCEPTED = 'URA',
  CANCEL_RETURN_REQUESTED = 'CRR',
  CANCEL_UPDATE_REQUESTED = 'CUR',
  PARTIALLY_FINISHED = 'PF'
}

export enum ParentAndChildStatusValues {
  TRANSMITTING = 'TRANSMITTING',
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  RETURNED = 'RETURNED',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  COMPLETED = 'COMPLETED',
  RETURN_REQUEST_ACCEPTED = 'RETURN_REQUEST_ACCEPTED',
  RETURN_REQUEST_DENIED = 'RETURN_REQUEST_DENIED',
  RETURN_ACCEPTED = 'RETURN_ACCEPTED',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_REQUESTED_RESPONDED = 'UPDATE_REQUESTED_RESPONDED',
  UPDATE_REQUESTED_ACCEPTED = 'UPDATE_REQUESTED_ACCEPTED',
  CANCEL_RETURN_REQUESTED = 'CANCEL_RETURN_REQUESTED',
  CANCEL_UPDATE_REQUESTED = 'CANCEL_UPDATE_REQUESTED'
}

export enum ParentAndChildStates {
  CHILD_ACCEPT = 'CHILD_ACCEPT',
  CHILD_DENY = 'CHILD_DENY',
  UPDATE_REQUEST = 'UPDATE_REQUEST',
  RETURN_REQUEST = 'RETURN_REQUEST',
  RETURNED = 'RETURNED',
  ACCEPTED = 'ACCEPTED'
}

export enum LoadBGColors {
  DEFAULT = 'white',
  REJECTED = '#fb363678',
  REROUTED = 'rgba(255,154,3,0.55)',
  RETURN_REQUESTED = '#e279e28f',
  RETURN_REQUEST_ACCEPTED = '#1dcc227d',
  RETURN_REQUEST_DENIED = '#ffc0cb',
  RETURNED = '#991dcc73',
  UPDATE_REQUESTED = '#f3c64b',
  PARTIALLY_FINISHED = '#ffff99'
}

export interface IDropCancelLoads {
  isOpen?: boolean;
  onCancel?: () => void;
  argLoads?: Partial<Load>[];
  callBack?: () => void;
  title?: string;
}

export interface IParamsForAccounts {
  paramColumnName: string;
  terminalIds: any[];
  isActiveOnly: boolean;
  commodityIds: any;
}
